import { render } from "./icon-item.vue?vue&type=template&id=3b4b3bd7&ts=true"
import script from "./icon-item.vue?vue&type=script&lang=ts"
export * from "./icon-item.vue?vue&type=script&lang=ts"

import exportComponent from "/azp/agent/_work/1/s/frontend-financier/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__